import { ReactElement, cloneElement } from "react";
import Svg from "react-native-svg";
import { iconSizeToIntConverter } from "./iconHelpers";
import { Box } from "@kolmeo/ui-core";
import type { IconProps } from "./types";

export type IconWrapperProps = IconProps & {
  children?: JSX.Element;
  testID?: string;
  title?: string;
  description?: string;
  viewBox: string;
};

const IconWrapper = ({
  children,
  title = "",
  description = "",
  viewBox,
  size,
  opacity,
  height,
  width,
  ...props
}: IconWrapperProps): ReactElement => {
  const svgSize = typeof size !== "number" ? iconSizeToIntConverter(size) : size;
  return (
    <Box {...props} width={width || svgSize} height={height || svgSize} accessibilityLabel={title} accessibilityHint={description}>
      <Svg width={width || svgSize} height={height || svgSize} viewBox={viewBox} opacity={opacity}>
        {children && cloneElement(children, { ...props })}
      </Svg>
    </Box>
  );
};

IconWrapper.defaultProps = {
  accessible: true,
  enableBackground: "new 0 0 30 30",
  viewBox: "0 0 30 30",
  size: "md",
};

export default IconWrapper;
